import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportingComponent } from './reporting.component';
import { BanglalinkReportComponent } from './banglalink-report/banglalink-report.component';
import { OperatorsComponent } from './operators/operators.component';
import { TrafficComponent } from './traffic/traffic.component';
import { AdsComponent } from './ads/ads.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',  
    pathMatch: 'full',  
  },
  {
    path: 'dashboard',
    component: ReportingComponent,
  },
  {
    path: 'operators',
    component: OperatorsComponent,
  },
  {
    path: 'traffic',
    component: TrafficComponent,
  },
  {
    path: 'ads',
    component: AdsComponent,
  },
  { path: '**', redirectTo: 'dashboard' }, // Redirect any unknown paths to the dashboard.
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportingRoutingModule {}
